import { render, staticRenderFns } from "./ContestLegals.vue?vue&type=template&id=e9050db2&scoped=true&"
import script from "./ContestLegals.vue?vue&type=script&lang=js&"
export * from "./ContestLegals.vue?vue&type=script&lang=js&"
import style0 from "./ContestLegals.vue?vue&type=style&index=0&id=e9050db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9050db2",
  null
  
)

export default component.exports